import request from '@utils/request'
import { ParamsProps, ReturnType } from './types'

const list = async (args: ParamsProps) => {
  try {
    const config: ReturnType = {
      url: 'push-notifications',
      method: 'get',
      authorization: true,
      params: args?.params,
      config: {
        showErr: true,
        store: {
          key: args?.state,
          action: 'set',
        },
      },
    }
    const response = await request(config)

    return response
  } catch (err: any) {
    throw new Error(err)
  }
}

const update = async (args: ParamsProps) => {
  try {
    const config: ReturnType = {
      url: `push-notifications/${args?.id}`,
      method: 'patch',
      authorization: true,
      data: args?.data,
      config: {
        successMsg: ' Updated Sucessfully',
        showErr: true,
        store: {
          key: args?.state,
          action: 'update',
        },
      },
    }
    const response = await request(config)
    return response
  } catch (err: any) {
    throw new Error(err)
  }
}
const create = async (args: ParamsProps) => {
  try {
    const config: ReturnType = {
      url: `push-notifications`,
      method: 'post',
      authorization: true,
      data: args?.data,
      config: {
        successMsg: ' created Sucessfully',
        showErr: true,
        store: {
          key: args?.state,
          action: 'prepend',
        },
      },
    }
    const response = await request(config)
    return response
  } catch (err: any) {
    throw new Error(err)
  }
}
const remove = async (args: ParamsProps) => {
  try {
    const config: ReturnType = {
      url: `push-notifications/${args?.id}`,
      method: 'delete',
      authorization: true,
      data: args?.data,
      config: {
        successMsg: 'Removed Sucessfully',
        showErr: true,
        store: {
          key: args?.state,
          action: 'remove',
        },
      },
    }
    const response = await request(config)
    return response
  } catch (err: any) {
    throw new Error(err)
  }
}

const resend = async (args: ParamsProps) => {
  try {
    const config: ReturnType = {
      url: `push-notifications/${args?.id}`,
      method: 'post',
      authorization: true,
      config: {
        successMsg: 'Notification sent Sucessfully',
        showErr: true,
      },
    }
    const response = await request(config)
    return response
  } catch (err: any) {
    throw new Error(err)
  }
}
export default {
  list,
  update,
  create,
  remove,
  resend,
}
